import { Component, OnInit, ViewChild, TemplateRef, ChangeDetectionStrategy, Inject } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { UntypedFormGroup, UntypedFormBuilder, Validators, UntypedFormControl } from '@angular/forms';
import { Product } from 'src/app/models/app.models';
import { Constant } from 'src/app/constants/constant';
import { MatDialog } from '@angular/material/dialog';
import { ProductService } from 'src/app/services/product.service';
import { CartService } from 'src/app/services/cart.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { UserService } from 'src/app/services/user.service';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { ShareComponent } from './share/share.component';
import { ReviewRatingService } from 'src/app/services/review-rating.service';
import { EcryptServiceService } from 'src/app/services/ecrypt-service.service';
import { environment } from 'src/environments/environment';
import { Meta, Title } from '@angular/platform-browser';
import { Clipboard } from '@angular/cdk/clipboard';
import { ImgPreviewComponent } from './img-preview/img-preview.component';
import { ConfigServiceService } from 'src/app/services/config-service.service';
import { DatePipe, DOCUMENT } from '@angular/common';
import { emailValidator } from 'src/app/shared/utils/calsoft-validators';
import { CommonService } from 'src/app/services/common.service';
import { CurrencyConversionService } from 'src/app/services/currency-conversion.service';
import { ProductDetailsMainSlider } from 'src/app/models/product-details-main-slider';
import { ProductDetailsThumbSlider } from 'src/app/models/product-details-thumb-slider';
import { SwiperConfigInterface } from 'src/app/theme/swiper/swiper.module';

@Component({
  selector: 'calsoft-product',
  templateUrl: './product.component.html',
  styleUrls: ['./product.component.scss'],
  changeDetection: ChangeDetectionStrategy.Default,
})
export class ProductComponent implements OnInit {
  @ViewChild('shareProduct') shareProduct: TemplateRef<any>;


  dropDownValue = new UntypedFormControl('');
  public image: any;
  public zoomImage: any;
  private sub: any;
  public form: UntypedFormGroup;
  public relatedProducts: Array<Product>;
  filterRequest: any[];
  images: Object;
  query: any;
  documentId: any;
  product: any;
  event: any;
  spec: any;
  value: any = [];
  url: string;
  fullurl: string;
  safeURL: any;
  mainImgPath: string;
  description: any
  shortDescription: any = [];
  public similarProducts: Array<Product>;
  recentlyViewedProducts: any = [];
  bigImage = environment.ImageAPI1;
  private smallImage = environment.ImageAPI;
  public youtubeUrl = environment.youtubeUrl;
  private thumnail = environment.thumnail;
  index: any;
  isOverlayVisible: boolean;
  reviewDetail: any = [];
  rating: any;
  highlighted: number;
  name: any;
  visible: boolean;
  isEmpty: boolean = false;
  seoValues: any;
  values: any;
  configurableProductDropdown: any = {};
  configurableProductActive: boolean = false;
  configurableProductId: any = 0;
  configProduct: any = {};
  configProductSelected: any = {};
  price: number;
  specialPrice: any;
  maintainStockIndConfProduct: any;
  manageImageSeperately: any;
  managePriceSeperately: any;
  productIdAddedInCart: any = {};
  qty: any;
  manageStock: any;
  isInStock: any;
  imageList: any = [];
  averageRating: any;
  calculateAvgRating: any;
  customProductElament: any = [];
  encryptedProductName: string;
  discountPercentage: any;
  relatedProductsList: any = [];
  upSellsProductsList: any = [];
  crossSellsProductsList: any = [];
  showTimeIcon: any;
  deliveryDoorStepIcon: any;
  deliveryTime: any;
  showGenuineProductIcon: any;
  genuineProductText: any;
  showConfigurableDropdown: any;
  deliveryDoorStepText: boolean;
  crossSellProductsText: any;
  relatedProductsText: any;
  recentlyViewedProductsText: any;
  upSellProductsText: any;
  videourl: string;
  videoAvaliable: boolean;
  genericName: any = null;
  prescriptionRequired: boolean = false;
  productNotAvaliable: boolean = false;
  productImageWidth: any;
  productImageType: any;
  data: any;
  productDetailImageWidth: any = 70;
  productzoom: any;
  productImageWidthMob: any;
  productImageHeightMob: any;
  showNewConfig: boolean = false;
  configattributeType: any;
  manageDescriptionSeperately: number;
  manageAdditionalInformationSeperately: number;
  manageNameSeperately: any;
  productDetailHeightMobile: any;
  productDetailWidthMobile: any;
  productDetailHeight: any;
  productDetailWidth: any;
  countryCode: any;
  units: any;
  showExclusivePrice: any = 0;
  tax: any;
  factBox: any;
  faq: any;
  SIDEEFFECTS: any = [];
  Commonsideeffects: any = [];
  SafetyAdvice: any;
  HOWTOUSE: any = [];
  UsesOf: any = [];
  Benefits: any = [];
  HowWorks: any = [];
  Ifmiss: any = [];
  productName: any;
  PregnancyInteraction: any;
  BreastfeedingInteraction: any;
  DrivingInteraction: any;
  KidneyInteraction: any;
  LiverInteraction: any;
  MANUFACTURER: any;
  SALTCOMPOSITION: any;
  STORAGES: any;
  factbox: any;
  ColdChain: any = [];
  productDetailPage: any;
  usageDetails = new Map<any, any>();
  itemDimensions = new Map<any, any>();
  sizeChartId: any;
  productDetailPageSubimageHeight: any;
  MapLink: any;
  decimalDigit: any;
  speechArray: any[];
  productDescription: any;
  coversionTrackingIdGa: any;
  visibleSpecification: any;
  featureSpecification: any;
  customField1: any;
  customField2: any;
  customField3: any;
  CourceDescription: any;
  CourseIncludes: any;
  LastUpdated: any;
  Language: any;
  Lecture: any;
  PdfDownload: any = 0;

  constructor(
    private activatedRoute: ActivatedRoute,
    public dialog: MatDialog,
    public formBuilder: UntypedFormBuilder,
    private productService: ProductService,
    private cartService: CartService,
    private snackBar: MatSnackBar,
    private _bottomSheet: MatBottomSheet,
    public userService: UserService,
    private router: Router,
    private reviewService: ReviewRatingService,
    private ecryptServiceService: EcryptServiceService,
    public meta: Meta, public title: Title,
    private clipboard: Clipboard,
    private configService: ConfigServiceService,
    public datepipe: DatePipe,
    private commonService: CommonService,
    private currencyConversionService: CurrencyConversionService,
    @Inject(DOCUMENT) private document: Document

  ) {


  }
  displayColdChain: boolean = false;
  showCartIcon: any;
  enableEnquire: any;
  showCartIncremented: any;
  categoryArray: any;
  indexConfig: any = 0;
  firstIndex: any = 0;
  secondIndex: any = 0;
  commonImageApi = environment.commonImageApiNew;

  public serverPath7 = environment.commonImageApi + "catalog/product";

  ngOnInit() {
    this.value = this.activatedRoute.snapshot.queryParamMap.get('sid');
    this.getConfigData();
    this.encryptedProductName = this.activatedRoute.snapshot.params['pid'];;
    this.getCustomerCount();
    this.highlighted = 0;
    this.sub = this.activatedRoute.params.subscribe(params => {
      this.name = params['name'];
      if (params['name'].includes("SLS")) {

        this.name = params['name'].replace(/SLS/g, '/');
      }


      this.name = this.name.replace(/_/g, ' ');
      this.name = this.name.replace(/plusAdd/g, '+');
      // this.name =this.name.replace(/&/g, '”');
      // this.name =this.name.replace(/Ro/g, '®');
      this.name = this.name.replace(/BRS/g, '(');
      this.name = this.name.replace(/BRE/g, ')');

      console.log("saz",this.encryptedProductName);
      this.getProducts(this.encryptedProductName);
      // this.getProductsImage(params['name']);

    });


    // this.sub = this.activatedRoute.params.subscribe(params => {
    //   this.getProductById(params['id']);
    // });4


    this.form = this.formBuilder.group({
      'review': [null, Validators.required],
      'name': [null, Validators.compose([Validators.required, Validators.minLength(4)])],
      'email': [null, Validators.compose([Validators.required, emailValidator])]
    });

    this.form = this.formBuilder.group({
      'review': [null, Validators.required],
      'name': [null, Validators.compose([Validators.required, Validators.minLength(4)])],
      'email': [null, Validators.compose([Validators.required, emailValidator])]
    });
    this.isOverlayVisible = false;


  }


  getCustomerCount() {

    let authourized = this.userService.getAuthenticatedUser();
    if (authourized) {




      this.cartService.getCustomerCartProductCount().subscribe(
        (response) => {


          this.values = response;

          let value = localStorage.getItem(Constant.CART_COUNT);
          if (value == null) {
            let encryptedValue = btoa(JSON.stringify(response));

            this.userService.storeProductCartCount(encryptedValue);
          }
        },
        (err) => { }
      );
    }
  }




  public selectImage(image, i) {
    this.highlighted = i;
    this.image = this.bigImage + image;
    this.zoomImage = this.bigImage + image;
  }

  public selectImage1(image, i) {
    this.highlighted = i;
    this.image = this.commonImageApi + image;
    this.zoomImage = this.commonImageApi + image;
  }





  // public openZoomViewer() {
  //   this.dialog.open(ProductZoomComponent, {
  //     data: this.zoomImage,
  //     panelClass: 'zoom-dialog'
  //   });
  // }

  ngOnDestroy() {
    this.sub.unsubscribe();
  }

  public onSubmit(values: Object): void {
    if (this.form.valid) {
    }
  }

  slideConfig = {
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: false,
    autoplaySpeed: 2000,
    dots: true,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          arrows: false,
          slidesToShow: 1
        }
      },
      {
        breakpoint: 480,
        settings: {
          arrows: false,
          slidesToShow: 1
        }
      }
    ]
  };

  amazonLink: any;
  amazonButtonEnabled: boolean = false;
  flipkartLink: any;
  flipkartButtonEnabled: boolean = false;
  configurationDropDownList = new Map<any, any>();
  productCustomOption: any;
  alcoholInteraction: any;
  buttonArray: any = [];
  //get Product  details
  getProducts(name) {


    this.filterRequest = [];
    const queryParams = this.router.parseUrl(this.router.url).queryParams;

    name = decodeURIComponent(name);
    if (name.includes("refId")) {
      const keyword = 'refid';
      const numberMatch = name.match(`(\\d+)(?=%.*${keyword})`);

      if (numberMatch && numberMatch.length > 0) {
        const number = parseInt(numberMatch[0]);

      } else {

      }

      name = parseInt(name.replace(/\D/g, ''));

      this.encryptedProductName = this.ecryptServiceService.encrypt(name)
    }

    if (!isNaN(name as any)) {
      name = parseInt(name.replace(/\D/g, ''));
      this.encryptedProductName = this.ecryptServiceService.encrypt(name)
    }



    this.productService.getProductDetailById(name)
      .subscribe(
        (response: any) => {

          if (response['data'] == null) {
            this.router.navigate(['/not-found'])
          } else {
            this.configProductSelected = response['data'];
            this.productIdAddedInCart = response['data'];
            this.product = response['data'];
            this.productIdAddedInCart = response['data'];
            this.productNotAvaliable = false;
            let refId = this.activatedRoute.snapshot.queryParamMap.get("refId");
            if (refId != null) {
              sessionStorage.setItem(Constant.REFERAL_ID, refId);
              sessionStorage.setItem(Constant.REFERRED_PRODUCT_ID
                , response['data']['entityId']);
            }

            this.speechArray=[];
            
        
            this.price = response['data']['price']
            this.specialPrice = response['data']['specialPrice'];
            this.discountPercentage = response['data']['discountPercentage'];
            this.productName = response['data']['name'];
            this.productDescription = response['data']['description'];

            let objectSpeechText=[
              this.productName,
              this.productDescription
            ]

            this.speechArray.push(objectSpeechText);
            // this.speechArray.push(this.price);    
            // this.speechArray.push(this.specialPrice);                        
            // this.speechArray.push(this.productDescription);            

            if( this.showExclusivePrice==1){
              if (this.product['isCustomizedValue'] != null) {
              if( this.product['isCustomizedValue']
              ['specialPriceWithoutTaxamount'] != null){
                this.specialPrice= this.product['isCustomizedValue']
                ['specialPriceWithoutTaxamount'];
              }
              if( this.product['isCustomizedValue']
              ['priceWithoutTaxamount'] != null){
                this.price= this.product['isCustomizedValue']
                ['priceWithoutTaxamount'];
              }
            }
            }
         
            if (response['data']['isCustomizedValue'] != null) {
              this.productCustomOption = response['data']['isCustomizedValue']['Custom Product Resource'];

              this.specialPrice = response['data']['specialPrice']
              this.b2bPricingEnabled = localStorage.getItem(Constant.B2B_USER)
                == null ? 0 : localStorage.getItem(Constant.B2B_USER);
              if (this.b2bPricingEnabled == 0) {
                this.price = response['data']['price'];
                this.specialPrice = response['data']['specialPrice'];
                if( this.showExclusivePrice==1){
                  if (this.product['isCustomizedValue'] != null) {
                  if( this.product['isCustomizedValue']
                  ['specialPriceWithoutTaxamount'] != null){
                    this.specialPrice= this.product['isCustomizedValue']
                    ['specialPriceWithoutTaxamount'];
                  }
                  if( this.product['isCustomizedValue']
                  ['priceWithoutTaxamount'] != null){
                    this.price= this.product['isCustomizedValue']
                    ['priceWithoutTaxamount'];
                  }
                }
                }
              } else {

                if (response['data']['isCustomizedValue']['Whole Sale Price'] != undefined) {


                  this.price = response['data']['isCustomizedValue']['Whole Sale Price'];

                  if (this.specialPrice == 0.0) {
                    this.specialPrice = response['data']['specialPrice']
                  }
                  this.specialPrice = response['data']['isCustomizedValue']['Whole Sale Discount Price'];

                  if (response['data']['isCustomizedValue']['Whole Sale Discount Percentage'] != undefined) {
                    this.discountPercentage = response['data']['isCustomizedValue']['Whole Sale Discount Percentage']
                  }
                  if (this.price == 0.0) {
                    this.price = response['data']['price']
                    this.specialPrice = response['data']['specialPrice']
                    this.discountPercentage = response['data']['discountPercentage'];

                    if (this.showExclusivePrice == 1) {
                      if (response['data']['isCustomizedValue']
                      ['specialPriceWithoutTaxamount'] != null) {
                        this.specialPrice = response['data']['isCustomizedValue']
                        ['specialPriceWithoutTaxamount'];
                      }
                      if (response['data']['isCustomizedValue']
                      ['priceWithoutTaxamount'] != null) {
                        this.price = response['data']['isCustomizedValue']
                        ['priceWithoutTaxamount'];
                      }
                    }
                  }




                }

                if (response['data']['isCustomizedValue']['Whole_Sale_Price'] != undefined) {


                  this.price = response['data']['isCustomizedValue']['Whole_Sale_Price'];

                  if (this.specialPrice == 0.0) {
                    this.specialPrice = response['data']['specialPrice']
                  }
                  this.specialPrice = response['data']['isCustomizedValue']['Whole_Sale_Discount_Price'];

                  if (response['data']['isCustomizedValue']['Whole_Sale_Discount_Percentage'] != undefined) {
                    this.discountPercentage = response['data']['isCustomizedValue']['Whole_Sale_Discount_Percentage']
                  }
                  if (this.price == 0.0) {
                    this.price = response['data']['price']
                    this.specialPrice = response['data']['specialPrice']
                    this.discountPercentage = response['data']['discountPercentage'];

                    if (this.showExclusivePrice == 1) {
                      if (response['data']['isCustomizedValue']
                      ['specialPriceWithoutTaxamount'] != null) {
                        this.specialPrice = response['data']['isCustomizedValue']
                        ['specialPriceWithoutTaxamount'];
                      }
                      if (response['data']['isCustomizedValue']
                      ['priceWithoutTaxamount'] != null) {
                        this.price = response['data']['isCustomizedValue']
                        ['priceWithoutTaxamount'];
                      }
                    }
                  }




                }else{
                  if( this.showExclusivePrice==1){
                    if (this.product['isCustomizedValue'] != null) {
                    if( this.product['isCustomizedValue']
                    ['specialPriceWithoutTaxamount'] != null){
                      this.specialPrice= this.product['isCustomizedValue']
                      ['specialPriceWithoutTaxamount'];
                    }
                    if( this.product['isCustomizedValue']
                    ['priceWithoutTaxamount'] != null){
                      this.price= this.product['isCustomizedValue']
                      ['priceWithoutTaxamount'];
                    }
                  }
                  }
                }

              }



              if (response['data']['isCustomizedValue']['sizeChart'] != null) {

                this.sizeChartId = response['data']['isCustomizedValue']['sizeChart']

              }

              if (response['data']['isCustomizedValue']['MapLink'] != null) {

                this.MapLink = response['data']['isCustomizedValue']['MapLink']

              }

              if (response['data']['isCustomizedValue']['Pdf Download'] != null) {

                this.PdfDownload = response['data']['isCustomizedValue']['Pdf Download']

              }

              if (response['data']['isCustomizedValue']['Course Description'] != null) {

                this.CourceDescription = response['data']['isCustomizedValue']['Course Description']

              }

              if (response['data']['isCustomizedValue']['Course Includes'] != null) {

                this.CourseIncludes = response['data']['isCustomizedValue']['Course Includes']

              }


              if (response['data']['isCustomizedValue']['Language'] != null) {

                this.Language = response['data']['isCustomizedValue']['Language']

              }

              if (response['data']['isCustomizedValue']['Last Updated'] != null) {

                this.LastUpdated = response['data']['isCustomizedValue']['Last Updated']

              }

              if (response['data']['isCustomizedValue']['Lecture'] != null) {

                this.Lecture = response['data']['isCustomizedValue']['Lecture']

              }

              if (response['data']['isCustomizedValue']
              ['Fragrance'] != null) {

                this.usageDetails.set('Fragrance', response['data']['isCustomizedValue']
                ['Fragrance']);
              }

              if (response['data']['isCustomizedValue']
              ['Electric'] != null) {

                this.usageDetails.set('Electric', response['data']['isCustomizedValue']
                ['Electric']);
              }

              if (response['data']['isCustomizedValue']
              ['Ideal For'] != null) {

                this.usageDetails.set('Ideal For', response['data']['isCustomizedValue']
                ['Ideal For']);
              }

              if (response['data']['isCustomizedValue']
              ['Diya Type'] != null) {

                this.usageDetails.set('Diya Type', response['data']['isCustomizedValue']
                ['Diya Type']);
              }

              if (response['data']['isCustomizedValue']
              ['Occasion'] != null) {

                this.usageDetails.set('Occasion', response['data']['isCustomizedValue']
                ['Occasion']);
              }

              if (response['data']['isCustomizedValue']
              ['Suitable For'] != null) {

                this.usageDetails.set('Suitable For', response['data']['isCustomizedValue']
                ['Suitable For']);
              }


              if (response['data']['isCustomizedValue']
              ['Net Quantity'] != null) {

                this.usageDetails.set('Net Quantity', response['data']['isCustomizedValue']
                ['Net Quantity']);
              }

              // itemDimensions

              if (response['data']['isCustomizedValue']
              ['Height'] != null) {

                this.itemDimensions.set('Height', response['data']['isCustomizedValue']
                ['Height']);
              }

              if (response['data']['isCustomizedValue']
              ['Length'] != null) {

                this.itemDimensions.set('Length', response['data']['isCustomizedValue']
                ['Length']);
              }

              if (response['data']['isCustomizedValue']
              ['Width'] != null) {

                this.itemDimensions.set('Width', response['data']['isCustomizedValue']
                ['Width']);
              }

              if (response['data']['isCustomizedValue']
              ['Net Weight'] != null) {

                this.itemDimensions.set('Net Weight', response['data']['isCustomizedValue']
                ['Net Weight']);
              }


              // this.factBox=response['data']['factbox']
              // this.factBox=response['data']['factbox']


              // factbox
              if (response['data']['isCustomizedValue']['FactBox'] != null) {
                this.factBox = JSON.parse(this.factbox = response['data']['isCustomizedValue']['FactBox']);
              }

              // Amazon
              if (response['data']['isCustomizedValue']['Amazon'] != null) {

                this.amazonLink = response['data']['isCustomizedValue']['Amazon'];
                this.amazonButtonEnabled = true;

                let object = {
                  "name": "Amazon",
                  "link": this.amazonLink
                }

                this.buttonArray.push(object)
              }

              // flipkart
              if (response['data']['isCustomizedValue']['Flipkart'] != null) {
                this.flipkartLink = response['data']['isCustomizedValue']['Flipkart'];
                this.flipkartButtonEnabled = true;
                let object = {
                  "name": "Flipkart",
                  "link": this.flipkartLink
                }
                this.buttonArray.push(object)
              }

              //UsesOf

              if (response['data']['isCustomizedValue']['UsesOf'] != null) {
                this.UsesOf = response['data']['isCustomizedValue']['UsesOf'].split("|");
              }

              //faq

              if (response['data']['isCustomizedValue']['faq'] != null) {
                this.faq = JSON.parse(response['data']['isCustomizedValue']['faq'])


              }

              // SideEffect
              if (response['data']['isCustomizedValue']['SIDEEFFECTS'] != null) {
                this.SIDEEFFECTS = response['data']['isCustomizedValue']['SIDEEFFECTS'].split("|");
              }

              //commonEffect
              if (response['data']['isCustomizedValue']['Commonsideeffects'] != null) {
                this.Commonsideeffects = response['data']['isCustomizedValue']['Commonsideeffects'].split("|");
              }

              //  SafetyAdvice

              if (response['data']['isCustomizedValue']['SafetyAdvice'] != null) {
                this.SafetyAdvice = JSON.parse(response['data']['isCustomizedValue']['SafetyAdvice'])


              }
              if (response['data']['isCustomizedValue'][' Alcohol interaction'] != null) {
                this.alcoholInteraction = response['data']['isCustomizedValue'][' Alcohol interaction']

              }
              if (response['data']['isCustomizedValue'][' Pregnancy interaction'] != null) {
                this.PregnancyInteraction = response['data']['isCustomizedValue'][' Pregnancy interaction']

              }
              if (response['data']['isCustomizedValue'][' Breast feeding interaction'] != null) {
                this.BreastfeedingInteraction = response['data']['isCustomizedValue'][' Breast feeding interaction']

              }
              if (response['data']['isCustomizedValue'][' Driving interaction'] != null) {
                this.DrivingInteraction = response['data']['isCustomizedValue'][' Driving interaction']

              }
              if (response['data']['isCustomizedValue'][' Kidney interaction'] != null) {
                this.KidneyInteraction = response['data']['isCustomizedValue'][' Kidney interaction']

              }
              if (response['data']['isCustomizedValue'][' Liver interaction'] != null) {
                this.LiverInteraction = response['data']['isCustomizedValue'][' Liver interaction']

              }


              //HOWTOUSE
              if (response['data']['isCustomizedValue']['HOWTOUSE'] != null) {
                this.HOWTOUSE = response['data']['isCustomizedValue']['HOWTOUSE'].split("Value");
              }

              //How Works
              if (response['data']['isCustomizedValue']['HowWorks'] != null) {
                this.HowWorks = response['data']['isCustomizedValue']['HowWorks'].split("Value");
              }

              //coldchain

              if (response['data']['isCustomizedValue']['ColdChain'] != null) {
                this.displayColdChain = true;
                this.ColdChain = response['data']['isCustomizedValue']['ColdChain'];
              }

              //Ifmiss
              if (response['data']['isCustomizedValue']['Ifmiss'] != null) {
                this.Ifmiss = response['data']['isCustomizedValue']['Ifmiss'].split("Value");
              }

              // Benefits
              if (response['data']['isCustomizedValue']['Benefits'] != null) {
                this.Benefits = response['data']['isCustomizedValue']['Benefits'].split("|");
              }

              // MANUFACTURER
              if (response['data']['isCustomizedValue']['MANUFACTURER'] != null) {
                this.MANUFACTURER = response['data']['isCustomizedValue']['MANUFACTURER'];
              }
              else {
                this.MANUFACTURER = null;
              }
              // SALTCOMPOSITION
              if (response['data']['isCustomizedValue']['SALTCOMPOSITION'] != null) {
                this.SALTCOMPOSITION = response['data']['isCustomizedValue']['SALTCOMPOSITION'];
              }
              else {
                this.SALTCOMPOSITION = null;
              }

              // STORAGES
              if (response['data']['isCustomizedValue']['STORAGES'] != null) {
                this.STORAGES = response['data']['isCustomizedValue']['STORAGES'];
              }
              else {
                this.STORAGES = null;
              }


              if (response['data']['isCustomizedValue']['manageAdditionalInformationSeperately'] != null) {
                this.manageAdditionalInformationSeperately = response['data']['isCustomizedValue']['manageAdditionalInformationSeperately']
              }

              if (response['data']['isCustomizedValue']['manageNameSeperately'] != null) {
                this.manageNameSeperately = response['data']['isCustomizedValue']['manageNameSeperately']
              }

              if (response['data']['isCustomizedValue']['manageDescriptionSeperately'] != null) {
                this.manageDescriptionSeperately = response['data']['isCustomizedValue']['manageDescriptionSeperately']
              }

              if (response['data']['isCustomizedValue']['Product SEO Name'] != null || response['data']['isCustomizedValue']['Product SEO Name'] != undefined) {
                this.seoValues = response['data']['isCustomizedValue']['Product SEO Name']
                this.title.setTitle(`${this.seoValues}`);
                if (response['data']['isCustomizedValue']['Meta Title'] != null || response['data']['isCustomizedValue']['Meta Title'] != undefined) {

                  this.meta.addTags([

                    { name: 'author', content: response['data']['isCustomizedValue']['Meta Title'] },

                  ]);

                } if (response['data']['isCustomizedValue']['Meta Keywords'] != null || response['data']['isCustomizedValue']['Meta Keywords'] != undefined) {
                  this.meta.addTags([
                    { name: 'keywords', content: response['data']['isCustomizedValue']['Meta Keywords'] },
                  ])



                } if (response['data']['isCustomizedValue']['Meta Description'] != null || response['data']['isCustomizedValue']['Meta Description'] != undefined) {
                  this.meta.addTags([
                    { name: 'description', content: response['data']['isCustomizedValue']['Meta Description'] },
                  ])

                }
              } else {
                this.title.setTitle('Buy ' + response['data']['name'] + " Online -" + Constant.siteName);
              }
            }
            else {
              this.title.setTitle('Buy ' + response['data']['name'] + " Online -" + Constant.siteName);
              this.meta.addTags([

                { name: 'keywords', content: response['data']['name'] },

              ]);
            }

            if (response['data'] != null) {

              //   this.getProductDetailReviewId(response['data']['entityId']);

              if (response['data']['units'] == 'sqft') {
                this.units = '/sqft'
              }

              this.spec = response['data']['additionalSpec'];
              this.description = response['data']['description']
              this.name = response['data']['name']
              this.shortDescription = response['data']['shortDescription']
              this.fullurl = this.url + "/" + response['videoUrl']
              this.productNotAvaliable = true;
              // this.safeURL = this._sanitizer.bypassSecurityTrustResourceUrl(this.fullurl);


              this.tax = response['data']['tax']



              this.visibleSpecification = response['data']['specDetail']
              this.featureSpecification = response['data']['featureList']
              this.customField1 = response['data']['customField1']
              this.customField2 = response['data']['customField2']
              this.customField3 = response['data']['customField3']

              this.averageRating = response['data']['averageRating'];
              this.calculateAvgRating = response['data']['calculateAvgRating'];

              if (response['data']['images'] != null) {
                this.imageList = response['data']['images'];
              } else {
                this.imageList = [];
              }


              this.qty = response['data']['qty'];
              this.manageStock = response['data']['manageStock'];
              this.isInStock = response['data']['isInStock'];

              if (response['data']['isCustomizedValue'] != null) {

                if (response['data']['isCustomizedValue']['Prescription Required'] != null && response['data']['isCustomizedValue']['Prescription Required'] != undefined && response['data']['isCustomizedValue']['Prescription Required'] != '') {

                  this.prescriptionRequired = response['data']['isCustomizedValue']['Prescription Required'] == 1 ? true : false;
                }

                if (this.product['isCustomizedValue']['Prescription_Required'] != null && this.product['isCustomizedValue']['Prescription_Required']
                  != undefined && this.product['isCustomizedValue']['Prescription_Required'] != '') {

                  this.prescriptionRequired = this.product['isCustomizedValue']['Prescription_Required'] == 1 ? true : false;
                }

                if (response['data']['isCustomizedValue']['Video ID'] != null && response['data']['isCustomizedValue']['Video ID'] != undefined && response['data']['isCustomizedValue']['Video ID'] != '') {
                  this.videourl = response['data']['isCustomizedValue']['Video ID'];
                  this.videoAvaliable = true;
                }
              }

              if (response['data']['isCustomizedValue']['Video_ID'] != null && response['data']['isCustomizedValue']['Video_ID'] != undefined && response['data']['isCustomizedValue']['Video_ID'] != '') {
                this.videourl = response['data']['isCustomizedValue']['Video_ID'];
                this.videoAvaliable = true;
              }

              if (response['data']['productImageUrl'] != null) {
                if (response['data']['productImageUrl'].includes("http")) {
                  this.image = response['data']['productImageUrl'];
                  this.zoomImage = response['data']['productImageUrl'];
                }
                else if (response['data']['productImageUrl'].includes("medicineimages")) {
                  this.image = this.commonImageApi + response['data']['productImageUrl'];
                  this.zoomImage = this.commonImageApi + "/" + response['data']['productImageUrl'];
                }
                else if (response['data']['productImageUrl'].includes("commonimages")) {
                  this.image = this.serverPath7 + response['data']['productImageUrl'];
                  this.zoomImage = this.serverPath7 + "/" + response['data']['productImageUrl'];
                } else {
                  this.image = this.bigImage + "/" + response['data']['productImageUrl'];
                  this.zoomImage = this.bigImage + "/" + response['data']['productImageUrl'];
                }
              }

              else {
                this.image = 'sassa';
                this.zoomImage = null;
              }


              if (this.spec != null && this.spec['Author'] != '' && this.spec['Author'] != undefined) {
                let _temp = {};
                _temp['Author'] = this.spec['Author'];
                this.filterRequest.push(_temp);

                //   this.getSimilarProducts(categoryId);

              }
              else if (this.spec != null && this.spec['Brand'] != '' && this.spec['Brand'] != undefined) {
                let _temp = {};
                _temp['Brand'] = this.spec['Brand'];
                this.filterRequest.push(_temp);
                if (this.spec['Product Type'] != '' && this.spec['Product Type'] != undefined) {
                  let _temp1 = {};
                  _temp1['Product Type'] = this.spec['Product Type'];
                  this.filterRequest.push(_temp1);
                }

                // this.getSimilarProducts(categoryId);
              }
              else if (this.spec != null && this.spec['Brands'] != '' && this.spec['Brands'] != undefined) {
                let _temp = {};
                _temp['Brands'] = this.spec['Brands'];
                this.filterRequest.push(_temp);

                //      this.getSimilarProducts(categoryId);
              }
              else {
                //   this.getSimilarProducts(categoryId);
              }
            }
            else {
              this.isEmpty = true
            }
            this.configurationDropDownList = new Map<any, any>();
            this.configurableProductDropdown = {}
            if ((response['data']['type'] == "Configurable" || response['data']['type'] == "Variants Subscription" || response['data']['type'] == "Variants")
              && response['data']['configurableProductDropdown'] != null) {
              this.configurableProductActive = true;
              this.configurableProductDropdown = response['data']['configurableProductDropdown'];
              this.maintainStockIndConfProduct = response['data']['maintainStockIndConfProduct'];
              this.manageImageSeperately = response['data']['maintainImageIndConfProduct'];
              this.managePriceSeperately = response['data']['maintainPriceIndConfProduct'];


              let i = 0;

              if (this.configurableProductDropdown['new'] != undefined) {

                this.configurationDropDownList = JSON.parse(this.configurableProductDropdown['new']);
                this.configProduct = response['data']['configProduct'];



                if (this.configurationDropDownList['length'] > 0 && this.activatedRoute.snapshot.params.psub != undefined) {
                  let productId = this.ecryptServiceService.decryptionAES(this.activatedRoute.snapshot.params.psub);


                  for (let i = 0; i < this.configurationDropDownList['length']; i++) {

                    this.firstIndex = i;
                    const item = this.configurationDropDownList[i];

                    const recursiveIndex = item.recursuive.findIndex(recursiveItem => recursiveItem.productId == productId);

                    if (recursiveIndex !== -1) {
                      this.secondIndex = recursiveIndex;
                      break;
                    }
                  }

                  this.configurableProductId = this.configurationDropDownList[this.firstIndex]
                  ['recursuive'][this.secondIndex].productId;
                  this.configProductSelected = JSON.parse(this.configProduct[this.configurableProductId]);
                }


                this.setConfigProductItem();
                this.showNewConfig = true;
              } else {

                this.configattributeType = this.configurableProductDropdown['configAttributeType']

                if (this.configattributeType == undefined) {
                  this.configattributeType = 1;
                }
                delete this.configurableProductDropdown['configAttributeType']
                for (let key of Object.keys(this.configurableProductDropdown)) {
                  if (i == 0) {
                    let value = this.configurableProductDropdown[key];
                    this.configProduct = response['data']['configProduct'];
                    this.getConfigProductId(value, 0);
                    // this.dropDownValue.patchValue(value);
                    // this.configurableProductId = value.split("#")[1];

                    //

                    // this.configProductSelected = JSON.parse(response['data']['configProduct'][this.configurableProductId]);

                  }

                  let valueList = [];
                  valueList = this.configurableProductDropdown[key].split(',')



                  this.configurationDropDownList.set(key, valueList)
                  i++;
                }


              }



            } else {
              this.getProductDetailReviewId(response['data']['entityId']);
            }

            this.sessionReq(response['data']['entityId']);

            if (response['data']['relatedProducts'] != null) {

              if (response['data']['relatedProducts'].length == 1) {

                if (response['data']['relatedProducts'][0] > 0) {
                  this.getLinkedProducts(response['data']['relatedProducts'], "relatedProducts")
                }


              } else if (response['data']['relatedProducts'].length > 0) {
                this.getLinkedProducts(response['data']['relatedProducts'], "relatedProducts")
              }

            }


            if (response['data']['upSells'] != null) {

              if (response['data']['upSells'].length == 1) {


                if (response['data']['upSells'][0] > 0) {
                  this.getLinkedProducts(response['data']['upSells'], 'upSells')
                }


              } else if (response['data']['upSells'].length > 0) {
                this.getLinkedProducts(response['data']['upSells'], 'upSells')
              }

            }


            if (response['data']['crossSells'] != null) {

              if (response['data']['crossSells'].length == 1) {


                if (response['data']['crossSells'][0] > 0) {
                  this.getLinkedProducts(response['data']['crossSells'], 'crossSells')
                }


              } else if (response['data']['crossSells'].length > 0) {
                this.getLinkedProducts(response['data']['crossSells'], 'crossSells')
              }
            }

            this.setPixel();
          }
        },
        error => {
        }
      );



  }

  setPixel() {

    let value = this.commonService.retrunProductUrl(this.product)
    this.url = this.document.location.origin + "/" + value
    let currency: any = localStorage.getItem('currency');

    this.meta.addTags([
      {
        name: 'og:title',
        content: this.product?.name
      },
      {
        name: 'og:type',
        content: 'product'
      },
      {
        name: 'og:description',
        content: this.description
      },
      {
        name: 'og:url',
        content: this.url
      },
      {
        name: 'og:image',
        content: this.image
      },
      {
        name: 'product:availability',
        content: 'in stock'
      },
      {
        name: 'product:condition',
        content: 'new'
      },
      {
        name: 'product:price:amount',
        content: this.price
      },
      {
        name: 'product:price:currency',
        content: currency
      },
    ]);
    if (this.product?.additionalSpec?.Brand?.length > 0) {
      this.meta.addTags([
        {
          name: 'product:brand',
          content: this.product.additionalSpec.Brand
        },
      ]);
    }


  }



  ///more images
  getProductsImage(name) {
    this.productService.getProductImage(name)
      .subscribe(
        data => {
          this.images = data;
        },
        error => {
        }
      );
  }
  //review deatil all id based
  getProductDetailReviewId(productId) {
    this.reviewService.getProductDetailReviewAll(productId)
      .subscribe(
        data => {
          this.reviewDetail = data;
        },
        error => {
        }
      );
  }

  getProductDetailReviewIdAndSubId(productId, subProductId) {
    this.reviewService.getProductDetailReviewVariant(productId, subProductId)
      .subscribe(
        data => {
          this.reviewDetail = data;
        },
        error => {
        }
      );
  }


  getSimilarProducts(categoryId) {
    let page = 0;
    let size = 12
    this.productService.RelatedProducts(categoryId, this.filterRequest, page, size).subscribe(
      res => {
        this.similarProducts = res['content'];


        error => {
        }
      }
    )
  }

  sessionReq(productId) {
    let basicAuthHeaderString = this.userService.getAuthenticatedToken();
    let username = this.userService.getAuthenticatedUser();
    if (basicAuthHeaderString && username) {

      let payload = {
        "productId": productId
      }
      this.productService.getSessionDetails(payload).subscribe(
        res => {
          this.recentlyViewedProducts = res['products'];

        }
      )
    }
    else {
      this.recentlyViewedProducts = [];
    }
  }


  public addToCart(product) {
    let cart = {
      "customerId": 38813,
      "itemsQty": 1,
      "currencyCode": "USD",
      "operationType": "New",
      "remoteIp": "192.168.5.99",
      "salesFlatQuoteItem": [
        {
          "productId": product.productId,
          "qty": 1,
          "operationType": "New",
        }
      ]
    }

    this.cartService.addCartItem(cart).subscribe(
      (response) => {
        if (response['status_code'] == Constant.RESPONSE_SUCCESS) {
          this.snackBar.open(response['status_message'], '×', { panelClass: 'success', verticalPosition: 'bottom', duration: 3000 });
        }
        else {
          this.snackBar.open(response['status_message'], '×', { panelClass: 'error', verticalPosition: 'bottom', duration: 3000 });
        }
      },
      (err) => { });
  }

  openBottomSheet(): void {
    this._bottomSheet.open(ShareComponent);
  }



  shareItem() {
    if (window.innerWidth > 768) {
      let dialogRef = this.dialog.open(this.shareProduct, {
        width: '400px',
        // data: { page: this.page1, }
      });
      dialogRef.disableClose = true;
      dialogRef.afterClosed().subscribe(result => {

      });
    }
    else {
      this._bottomSheet.open(ShareComponent);
    }

  }

  closeShare() {
    this.dialog.closeAll()
  }

  emi() {
    //let url2 = 'http://localhost:4200/#/easypayment'
    let url2 = 'https://devapp.calsoftgroup.com/calsoftweb/#/easypayment/'
    this.commonService.goToLink(url2)
  }

  brand(Nikon) {
    this.router.navigate(['/products/search/', Nikon])

  }

  facebook() {
    let url = 'https://www.facebook.com/sharer/sharer.php?u=' + encodeURIComponent(location.href)
    'facebook-share-dialog'
    this.commonService.goToLink(url)

  }

  whatsapp() {
    let currentURL = window.location.href
    let url = `https://web.whatsapp.com/send?text=${currentURL}`
    this.commonService.goToLink(url)
  }

  copy() {
    let currentURL = window.location.href
    this.clipboard.copy(`${currentURL}`);
    this.snackBar.open(`Copied `, '×', { panelClass: 'success', verticalPosition: 'bottom', duration: 3000 });
  }






  mailTo() {
    let currentURL = window.location.href
    let url = `mailto:?subject=${currentURL}`
    this.commonService.goToLink(url)

  }


  customProductMap = new Map<any, any>();
  salesFlatQuoteItemOption: any = [];
  updateCheckedOptions(event, j, primaryIndex, secondaryIndex, secondaryId, final) {
    let entityId = this.customProductElament[primaryIndex].productCustomizationList[secondaryIndex]['entityId']
    let childKey = this.customProductElament[primaryIndex].productCustomizationList[secondaryIndex]['key']
    if (event.checked) {
      this.customProductMap.set(primaryIndex, secondaryId);
      let price = final;
    } else {
      this.customProductMap.delete(primaryIndex);
      let index = this.salesFlatQuoteItemOption.findIndex(x => x.code == childKey);
      this.salesFlatQuoteItemOption.splice(index, 1);
    }
  }

  getSalesFlatQuoteItemOption(i) {
    this.salesFlatQuoteItemOption = i;
  }



  getLinkedProducts(productIds, type) {

    this.productService.productLinked(productIds).subscribe(
      res => {

        if (res['status_code'] == Constant.RESPONSE_SUCCESS) {

          if (type == 'relatedProducts') {
            this.relatedProductsList = res['datalist']
          } else if (type == 'upSells') {
            this.upSellsProductsList = res['datalist']
          } else if (type == 'crossSells') {
            this.crossSellsProductsList = res['datalist']
          }


        } else {

        }



      },
      error => {

      }
    )
  }
  productImageHeight: any;
  b2bPricingEnabled: any;

  getConfigData() {
    this.configService.getConfigData()
      .subscribe(
        data => {
          localStorage.setItem(Constant['GUEST_LOGIN'], data['guestLogin'])

          let url = data['baseUrl'] + this.router.url;

          this.meta.updateTag({ rel: 'canonical', href: url });

          this.commonService.setCurrencyValue(data['currencyBase']);

          this.coversionTrackingIdGa = data['coversionTrackingIdGa'];

          this.showCartIcon = data['showCartProductPage'];

          this.enableEnquire = data['enableEnquire'];

          this.b2bPricingEnabled = data['b2bPricingEnabled'];

          this.decimalDigit=data['decimalDigit'];
          
          this.showCartIncremented = data['showCartIncremented']

          this.deliveryDoorStepIcon = data['deliveryDoorStepIcon'] == 1 ? true : false

          this.deliveryTime = data['deliveryTime']

          this.showTimeIcon = data['showTimeIcon'] == 1 ? true : false

          this.showGenuineProductIcon = data['showGenuineProductIcon'] == 1 ? true : false;

          this.genuineProductText = data['genuineProductText']

          this.deliveryDoorStepText = data['deliveryDoorStepText'];

          this.showConfigurableDropdown = data['showConfigurableDropdownProductPage'];

          this.productDetailPage = data['productDetailPage'];

          if(this.router.url.includes('/course/')){
            this.productDetailPage=14
          }

          ///

          this.crossSellProductsText = data['crossSellProductsText']

          this.relatedProductsText = data['relatedProductsText'];

          this.recentlyViewedProductsText = data['recentlyViewedProductsText']

          this.upSellProductsText = data['upSellProductsText']

          this.productImageHeight = data['productsImageHeight']

          this.productImageWidth = data['productsImageWidth']

          this.productImageType = data['productsImageType']

          this.productDetailImageWidth = data['productImageWidth']

          this.productzoom = data['productzoom']

          this.data = data;

          this.productImageWidthMob = data['productsImageWidthMob']

          this.productImageHeightMob = data['productsImageHeightMob'];


          this.productDetailHeight = data['productImageHeight'];
          this.productDetailWidth = data['producImageWidth'];

          this.productDetailHeightMobile = data['productMImageHeight'];
          this.productDetailWidthMobile = data['productMImageWidth'];

          this.showExclusivePrice = data['showExclusivePrice']

          this.productDetailPageSubimageHeight = data['productDetailPageSubimageHeight'];

          // this.freeShippingAppliedAmount=data['freeShippingAppliedAmount'];
          // this.ownerPostCode=data['zipPostCode'];
          // this.ownerCountryID=data['country'];
        }, error => {

        }
      );
  }
  public config: SwiperConfigInterface = {};
  ngAfterViewInit() {
    this.config = {
      observer: true,
      slidesPerView: 2,
      spaceBetween: 10,
      keyboard: true,
      navigation: true,
      pagination: false,
      grabCursor: true,
      loop: false,
      preloadImages: false,
      lazy: true,
      breakpoints: {
        480: {
          slidesPerView: 3
        },
        740: {
          slidesPerView: 3
        },
        960: {
          slidesPerView: 3
        },
        1280: {
          slidesPerView: 4
        },
        1500: {
          slidesPerView: 6
        }
      }
    }
  }


  getConfigProductId(event, index) {


    let productId = this.ecryptServiceService.decryptionAES(this.activatedRoute.snapshot.params.psub);


    index = event.split(",").findIndex(substring => substring.includes(productId));


    this.firstIndex = index;
    //  let value = event.split("#")[0];
    if (event.includes(",")) {
      event = event.split(",")[index];
    }
    this.configurableProductId = event.split("#")[1];
    this.configProductSelected = JSON.parse(this.configProduct[this.configurableProductId]);
    this.dropDownValue.patchValue(event);
    this.setConfigProductItem();
  }

  getConfigProductIdNew(event, i, value, index) {
    if (event.isUserInput != false) {
      this[index] = i;

      this.configurableProductId = this.configurationDropDownList[this.firstIndex]
      ['recursuive'][this.secondIndex].productId;
      this.configProductSelected = JSON.parse(this.configProduct[this.configurableProductId]);
      this.setConfigProductItem();
    }
  }

  setConfigProductItem() {
    if (this.product['type'] == "Configurable") {
      this.getProductDetailReviewId(this.configurableProductId);
    }

    if (this.product['type'] == "Variants" || this.product['type'] == "Variants Subscription") {

      this.getProductDetailReviewIdAndSubId(this.configurableProductId, this.product.entityId);
      if (this.configProductSelected['isCustomizedValue'] != null) {

        if (this.configProductSelected['isCustomizedValue']['Prescription Required']
          != null) {

          this.prescriptionRequired = this.configProductSelected['isCustomizedValue']['Prescription Required'] == 1 ? true : false;
        }
      }

    }

    if (this.showExclusivePrice == 1) {
      if (this.configurableProductId['isCustomizedValue'] != null) {
        if (this.configurableProductId['isCustomizedValue']
        ['specialPriceWithoutTaxamount'] != null) {
          this.specialPrice = this.configurableProductId['isCustomizedValue']
          ['specialPriceWithoutTaxamount'];
        }
        if (this.configurableProductId['isCustomizedValue']
        ['priceWithoutTaxamount'] != null) {
          this.price = this.configurableProductId['isCustomizedValue']
          ['priceWithoutTaxamount'];
        }



      }
    }
    if (this.managePriceSeperately == 1) {

      this.price = this.configProductSelected['price'];
      this.specialPrice = this.configProductSelected['specialPrice'];

      this.discountPercentage = this.configProductSelected['discountPercentage'];
      if (this.configProductSelected['isCustomizedValue'] != null) {
        this.b2bPricingEnabled = localStorage.getItem(Constant.B2B_USER) == null ? 0 : localStorage.getItem(Constant.B2B_USER);
        if (this.b2bPricingEnabled == 0) {
          this.price = this.configProductSelected['price'];
          this.specialPrice = this.configProductSelected['specialPrice'];
        } else {

          if (this.configProductSelected['isCustomizedValue']['Whole Sale Price'] != undefined) {


            this.price = this.configProductSelected['isCustomizedValue']['Whole Sale Price'];

            this.specialPrice = this.configProductSelected['isCustomizedValue']['Whole Sale Discount Price'];
            this.discountPercentage = this.configProductSelected['discountPercentage'];
            if (this.price == 0.0) {
              this.price = this.configProductSelected['price'];
              this.specialPrice = this.configProductSelected['specialPrice'];
              this.discountPercentage = this.configProductSelected['discountPercentage'];
            } else {
              if (this.configProductSelected['isCustomizedValue']['Whole Sale Discount Percentage'] != null) {
                this.discountPercentage = parseFloat(this.configProductSelected['isCustomizedValue']['Whole Sale Discount Percentage']);
              }
            }








          }

          if (this.configProductSelected['isCustomizedValue']['Whole_Sale_Price'] != undefined) {


            this.price = this.configProductSelected['isCustomizedValue']['Whole_Sale_Price'];

            this.specialPrice = this.configProductSelected['isCustomizedValue']['Whole_Sale_Discount_Price'];
            this.discountPercentage = this.configProductSelected['discountPercentage'];
            if (this.price == 0.0) {
              this.price = this.configProductSelected['price'];
              this.specialPrice = this.configProductSelected['specialPrice'];
              this.discountPercentage = this.configProductSelected['discountPercentage'];
            } else {
              if (this.configProductSelected['isCustomizedValue']['Whole_Sale_Discount_Percentage'] != null) {
                this.discountPercentage = parseFloat(this.configProductSelected['isCustomizedValue']['Whole_Sale_Discount_Percentage']);
              }
            }








          }
        }
      }


    }
    if (this.maintainStockIndConfProduct == 1) {
      this.qty = this.configProductSelected['qty'];
      this.manageStock = this.configProductSelected['manageStock'];
      this.isInStock = this.configProductSelected['isInStock'];
      this.productIdAddedInCart = this.configProductSelected;
      this.averageRating = this.configProductSelected['averageRating'];
      this.calculateAvgRating = this.configProductSelected['calculateAvgRating'];

    }


    if (this.manageAdditionalInformationSeperately == 1) {
      this.spec = this.configProductSelected['additionalSpec'];
    }


    if (this.manageDescriptionSeperately == 1) {
      this.description = this.configProductSelected['description'];
    }

    if (this.manageNameSeperately == 1) {
      this.name = this.configProductSelected['name'];
    }

    if (this.manageImageSeperately == 1) {

      if (this.configProductSelected['productImageUrl'] == null) {
        this.image = 'assets/images/products/noImage/no-image.png';
        this.zoomImage = 'assets/images/products/noImage/no-image.png';
        this.imageList = this.configProductSelected['images'];
      } else {
        if (this.configProductSelected['productImageUrl'] != 'no_selection') {
          if (this.configProductSelected['productImageUrl'].includes('http')) {
            this.image = this.configProductSelected['productImageUrl'];
            this.zoomImage = this.configProductSelected['productImageUrl'];
          } else if (this.configProductSelected['productImageUrl'].includes("medicineimages")) {
            this.image = this.commonImageApi + this.configProductSelected['productImageUrl'];
            this.zoomImage = this.commonImageApi + "/" + this.configProductSelected['productImageUrl'];
          }
          else if (this.configProductSelected['productImageUrl'].includes("commonimages")) {
            this.image = this.serverPath7 + this.configProductSelected['productImageUrl'];
            this.zoomImage = this.serverPath7 + "/" + this.configProductSelected['productImageUrl'];
          }
          else {
            this.image = this.bigImage + "/" + this.configProductSelected['productImageUrl'];
            this.zoomImage = this.bigImage + "/" + this.configProductSelected['productImageUrl'];
          }
        } else {
          this.image = this.configProductSelected['productImageUrl'];
          this.zoomImage = this.configProductSelected['productImageUrl'];
        }

        this.imageList = this.configProductSelected['images'];


        if (this.imageList == null) {
          this.imageList = []
        }
        if (this.imageList[0] == undefined) {
          this.image = "assets/images/products/noImage/no-image.png";
          this.zoomImage = "assets/images/products/noImage/no-image.png";
        }





      }
    }
  }

  getConfigProductIdButton(i, index) {

    this[index] = i;
    this.configurableProductId = this.configurationDropDownList[this.firstIndex]
    ['recursuive'][this.secondIndex].productId;
    this.configProductSelected = JSON.parse(this.configProduct[this.configurableProductId]);
    this.setConfigProductItem();

  }

  getImageproductId(productId) {

    let value = JSON.parse(this.configProduct[productId]);
    if (value.productImageUrl != undefined) {

      if (value.productImageUrl.includes("http")) {
        return value.productImageUrl;

      }
      else if (value.productImageUrl.includes("medicineimages")) {
        return this.commonImageApi + value.productImageUrl;

      }
      else if (value.productImageUrl.includes("commonimages")) {
        return this.serverPath7 + value.productImageUrl;

      } else {
        return this.bigImage + "/" + value.productImageUrl;

      }
    } else {
      return value.productImageUrl
    }



  }






  getImageproductIdOld(event) {

    let productId = event.split("#")[1];
    let value = JSON.parse(this.configProduct[productId]);

    if (value.productImageUrl.includes("http")) {
      return value.productImageUrl;

    }
    else if (value.productImageUrl.includes("medicineimages")) {
      return this.commonImageApi + value.productImageUrl;

    }
    else if (value.productImageUrl.includes("commonimages")) {
      return this.serverPath7 + value.productImageUrl;

    } else {
      return this.bigImage + "/" + value.productImageUrl;

    }

  }




  public ProductDetailsThumbConfig: any = ProductDetailsThumbSlider;
  public ProductDetailsMainSliderConfig: any = ProductDetailsMainSlider;

  public activeSlide: any = 0;

}
